import React from "react";

const AuthCallback = () => {
  return <div>AuthCallback</div>;
};

export default AuthCallback;
